/** How the attachment viewer shows a file (C5). */
export type AttachmentViewKind = 'image' | 'pdf' | 'text' | 'download';

export function attachmentViewKind(mime: string | null | undefined): AttachmentViewKind {
  const m = (mime ?? '').toLowerCase();
  if (m === 'image/tiff') return 'download'; // browsers cannot render TIFF
  if (m.startsWith('image/')) return 'image';
  if (m === 'application/pdf') return 'pdf';
  if (m === 'text/plain') return 'text';
  return 'download';
}

/** Bytes as "12,3 kB" style text (1 kB = 1000 B). */
export function formatAttachmentBytes(bytes: number | null | undefined, locale = 'da-DK'): string {
  if (bytes === null || bytes === undefined || !Number.isFinite(bytes)) return '—';
  if (bytes < 1000) return `${bytes} B`;
  const units = ['kB', 'MB', 'GB'];
  let value = bytes / 1000;
  let unit = 0;
  while (value >= 1000 && unit < units.length - 1) {
    value /= 1000;
    unit += 1;
  }
  return `${value.toLocaleString(locale, { maximumFractionDigits: 1 })} ${units[unit]}`;
}

export function base64ToBlob(base64: string, mime: string): Blob {
  const binary = atob(base64.replace(/\s+/g, ''));
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}

/** XBIN stores the UUID with dashes (09c27064-467e-4d00-a5d2-1152e260a001);
 *  referrals.attachments stores it without (09c27064467e4d00a5d21152e260a001).
 *  Strip non-alphanumeric characters and lowercase so both sides match. */
export function normalizeObjectIdentifier(value: string | null | undefined): string {
  return (value ?? '').replace(/[^0-9a-zA-Z]/g, '').toLowerCase();
}
